import {
    useDispatch,
    useSelector,
    type TypedUseSelectorHook,
} from "react-redux";

import type { AppDispatch, RootState } from "./store";

export default function useRedux() {
    const useAppDispatch = () => useDispatch<AppDispatch>();
    const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

    return {
        useAppDispatch,
        useAppSelector,
    };
}
